import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Button } from "./ui/button";
import { HelpCircle } from "lucide-react";
import { mockData } from "../data/mock";

const FAQSection = () => {
  return (
    <section className="py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <HelpCircle className="h-4 w-4" />
            Support
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-credentra-dark-teal mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Get quick answers to common questions about Credentra and FICA tip credit recovery
          </p>
        </div>
        
        <div className="space-y-6">
          <Accordion type="single" collapsible className="space-y-4">
            {mockData.faqItems.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="modern-card border-0 shadow-sm overflow-hidden"
              >
                <AccordionTrigger className="text-left text-credentra-dark-teal font-semibold hover:text-credentra-bright-teal px-8 py-6 text-lg transition-colors duration-300 hover:no-underline">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 px-8 pb-6 text-base leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl p-8 border border-gray-200">
            <h3 className="text-2xl font-bold text-credentra-dark-teal mb-4">
              Still have questions?
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              Our founding team is here to help you understand how Credentra can work for your business.
            </p>
            <Button 
              size="lg"
              className="text-white font-semibold text-lg px-10 py-6 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
              style={{background: 'linear-gradient(135deg, #00d6cf, #3c778d)', boxShadow: '0 4px 20px rgba(0, 214, 207, 0.3)'}}
              onClick={() => window.open('mailto:jonathan@credentra.ai?subject=Requesting more info', '_self')}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;